<template>
  <div style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%;">
      <el-header class="padding" height="6%">
        <el-form label-width="10px">
          <el-row>
<!--            <el-form-item>-->
<!--              <el-select v-model="productiveThing" @change="changeProductiveThing" filterable clearable-->
<!--                         placeholder="物件番号">-->
<!--                <el-option v-for="item in productiveThings" :key="item.value" :label="item.label"-->
<!--                           :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-date-picker v-model="productiveYear" :clearable="false" format="YYYY 年" value-format="YYYY"
                              type="year"
                              @change="productiveChangeYear(productiveYear)" placeholder="请选择年份"/>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="productiveMonth" format="M 月" value-format="YYYY-M-1" type="month"
                              @change="productiveChangeMonth(productiveMonth)" placeholder="请选择月份"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 80px" :loading="productiveSearchLoading"
                         @click="getProductiveMonthProcessReality">搜索
              </el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-header>
      <el-main class="padding" >
        <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center', width: '100%',}" :data="productiveTableData.slice((productivePageNum - 1) * productivePageSize, productivePageNum * productivePageSize)" border  style="width: 100%;height:92%;">
          <el-table-column prop="name" :label="$t('makeSchedule.processProduceAchievement.xiangCi')" :width="160" fixed/>
          <el-table-column v-for="item in countDayList" :key="item" :prop="item"
                           :label="countDayList.length > 12?((productiveMonth.slice(5,7).includes('-')? '0' + productiveMonth.slice(5,6):productiveMonth.slice(5,7)) + '/' + item):item <= 3?nextYear + '年' + item + '月':yarn + '年' + item  + '月'">
            <template v-slot="scope">
              <div v-for="day in scope.row.busObjectList" :key="day">
                <div v-if="day.date == item && day.name == '直接人工'">{{ day.directTotalCnt }}</div>
                <div v-if="day.date == item && day.name == '总人工（含间接）'">{{ day.indirectTotalCnt }}</div>
                <div v-if="day.date == item && day.name == '生产重量（kg）'">{{ day.realityWeight }}</div>
                <div v-if="day.date == item && day.name == '直接生产性'">{{ day.directProductivity }}</div>
                <div v-if="day.date == item && day.name == '总生产性（kg/人工）'">{{ day.productivity }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageStyle">
          <el-pagination style="margin-right: 13px" background layout="total, prev, pager, next" :total="productiveTableData.length" :current-page="productivePageNum" @current-change="productiveCurrentCheckChange" :page-sizes="productivePageSize" ></el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ProcessProductive",
  data(){
    return{
      productiveThing:'',
      productiveThings:[],
      productiveMonth : '',
      productiveYear:this.$common.getCurrentYearByMonth().toString(),
      yarn: new Date().getUTCFullYear(),
      nextYear : this.getDateFormat(),
      productiveSearchLoading:false,
      countDayList:[],
      productiveTableData:[],
      productiveTotal: 0,
      productivePageNum: 1,
      productivePageSize: 15,
    }
  },methods:{
    getDateFormat(){
      return moment().add(1, 'year').format("yyyy");
    },
// 获取一个月有多少天，month是开始日期，获取这个日期的月份的天数
    getCountDays(month) {
      const d = new Date(month)
      const y = this.productiveYear
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    // changeProductiveThing() {
    //   this.getProductiveMonthProcessReality();
    // },
    productiveChangeMonth(month) {
      this.countDayList = [];
      this.getCountDays(month);
      this.getProductiveMonthProcessReality();
    },
    productiveChangeYear() {
      this.getProductiveMonthProcessReality();
    },
    getProductiveMonthProcessReality() {
      console.log("getProductiveMonthProcessReality======")
      if (!this.productiveYear) {
        return this.$message.error("年不能为空");
      }

      let params
      if (!this.productiveMonth) {
        params = {month:this.productiveMonth,year:this.productiveYear}
      } else {
        params = {countDayList: this.countDayList, month:this.productiveMonth,year:this.productiveYear};
      }
      this.productiveSearchLoading = true;
      this.$axios.post('mfg/processProduceAchievement/getProductiveMonthProcessReality', params).then(response => {
        this.productiveSearchLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        if (!this.productiveMonth) {
          this.countDayList = res.data.countDayList;
          this.productiveTableData = res.data.busObjectList;
        } else {
          this.productiveTableData = res.data.busObjectList;
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },
    productiveCurrentCheckChange(pageNum) {
      this.productivePageNum = pageNum
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getWujianNames');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.productiveThings = res.data;
    },
  },created() {
    this.getWuJianInFo();
    this.getProductiveMonthProcessReality();
  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}
</style>